/*
 * NUVORA assistant.
 *
 * Layer 1 (always on, no network): matches the visitor's question against the
 * knowledge base below and answers from it. Every fact here is taken from the
 * live site — product pages, the FAQ and the sample report — so the assistant
 * cannot invent pricing or turnaround times.
 *
 * Layer 2 (optional): if an endpoint is configured, questions layer 1 cannot
 * match confidently are forwarded to it. With no endpoint, the assistant says
 * so and offers the contact page. It never guesses.
 *
 * Prices, handles and URLs come from Liquid via #nuvora-chat-data, so they
 * follow the catalogue rather than being duplicated here.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('nuvora-chat-data');
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var launcher = document.getElementById('nvc-launcher');
  var panel = document.getElementById('nvc-panel');
  var log = document.getElementById('nvc-log');
  var chips = document.getElementById('nvc-chips');
  var form = document.getElementById('nvc-form');
  var input = document.getElementById('nvc-input');
  var closeBtn = document.getElementById('nvc-close');
  if (!launcher || !panel || !log || !form || !input) return;

  var history = [];
  var started = false;
  var NAME = DATA.name || 'Vera';

  /* ---------------------------------------------------------------- helpers */

  function product(handle) {
    for (var i = 0; i < DATA.products.length; i++) {
      if (DATA.products[i].handle === handle) return DATA.products[i];
    }
    return null;
  }

  function priceOf(handle) {
    var p = product(handle);
    return p ? p.priceFormatted : '';
  }

  function cta(label, href) {
    return '<a class="nvc-cta" href="' + href + '">' + label + '</a>';
  }

  var BROWSE = function () {
    return cta('See all reports', DATA.collectionUrl);
  };

  /* ------------------------------------------------------------ knowledge */
  /* Each entry: cues to match on, and an answer. Answers are functions so
     they can read live prices. Keep cues lowercase. */

  var KB = [
    {
      id: 'pricing',
      // No price figures as cues: prices change in admin and stale cues would
      // rot. The answer reads them live from Liquid instead.
      cues: ['price', 'pricing', 'cost', 'how much', 'expensive',
             'cheap', 'afford', 'rand', 'fee', 'charge', 'payment'],
      answer: function () {
        var rows = DATA.products.map(function (p) {
          return '<li><strong>' + p.title + '</strong> — ' + p.priceFormatted + '</li>';
        }).join('');
        return '<p>Here is the full range:</p><ul>' + rows + '</ul>' +
               '<p>The Full Look (for her) and The Full Upgrade (for him) are the best ' +
               'value: the Blueprint, a guide, Hairstyle and priority delivery in one report.</p>' + BROWSE();
      }
    },
    {
      id: 'whats-included',
      cues: ['what do i get', 'what is included', "what's included", 'include',
             'contain', 'what do you provide', 'what is in the report', 'sections',
             'deliverable', 'receive'],
      answer: function () {
        return '<p>The Blueprint (' + priceOf('nuvora-complete-blueprint') +
          ') covers:</p><ul>' +
          '<li>Facial proportions &amp; symmetry</li>' +
          '<li>Eye region</li>' +
          '<li>Lips &amp; lower third</li>' +
          '<li>Nose &amp; profile</li>' +
          '<li>Skin</li>' +
          '<li>Jaw &amp; lower face</li></ul>' +
          '<p>Each area gets a written interpretation and a recommended direction, ' +
          'plus an overall harmony summary with your highest-impact and ' +
          'lowest-effort changes.</p>' +
          '<p>The Makeup Guide, Grooming Guide and Hairstyle each go deeper into one ' +
          'area, and each can be bought on its own or with the Blueprint.</p>' +
          cta('View The Blueprint', '/products/nuvora-complete-blueprint');
      }
    },
    {
      id: 'delivery',
      cues: ['how long', 'delivery', 'turnaround', 'when will i', 'how fast',
             'wait', 'days', 'quick', 'speed', 'rush', 'urgent', '48'],
      answer: function () {
        return '<p>Standard delivery is <strong>3 to 5 business days</strong> from ' +
          'when you submit your photos.</p>' +
          '<p>The Full Look and The Full Upgrade include delivery within 48 hours of receiving your photos and completed intake form, at no extra cost.</p>' +
          '<p>With anything else, Priority Delivery (' + priceOf('priority-delivery') +
          ') moves you to the front of the queue and delivers within 48 hours.</p>' +
          cta('Add Priority Delivery', '/products/priority-delivery');
      }
    },
    {
      id: 'photos',
      cues: ['photo', 'picture', 'image', 'selfie', 'camera', 'upload', 'angle',
             'what do you need from me', 'submit'],
      answer: function () {
        return '<p>Five photos, taken on a phone in natural light against a plain ' +
          'wall:</p><ul>' +
          '<li>One front-facing</li>' +
          '<li>Two three-quarter angles (left and right 45°)</li>' +
          '<li>Two profiles (left and right)</li></ul>' +
          '<p>No special equipment needed. The two side views matter most — they ' +
          'are what allow the profile section to be built at all. You get a secure ' +
          'upload link by email right after checkout.</p>' +
          cta('See the full photo guide', DATA.howItWorksUrl);
      }
    },
    {
      id: 'bundle',
      cues: ['bundle', 'everything', 'all of it', 'full package', 'best value', 'full look', 'full upgrade',
             'difference between', 'which should i', 'which one', 'recommend',
             'compare', 'vs'],
      answer: function () {
        return '<p>Quick guide. Every product can be bought on its own:</p><ul>' +
          '<li><strong>Makeup Guide, Grooming Guide or Hairstyle</strong> (' + priceOf('nuvora-hairstyle-recommendations') +
          ' each) — one area in depth.</li>' +
          '<li><strong>The Blueprint</strong> (' + priceOf('nuvora-complete-blueprint') +
          ') — your full face analysis.</li>' +
          '<li><strong>The Full Look</strong> (' + priceOf('nuvora-complete-bundle') +
          ') — for her: the Blueprint, the Makeup Guide and Hairstyle, plus priority delivery within 48 hours.</li>' +
          '<li><strong>The Full Upgrade</strong> (' + priceOf('nuvora-full-upgrade') +
          ') — for him: the Blueprint, the Grooming Guide (beard, grooming and eyewear) and Hairstyle, plus priority delivery within 48 hours.</li></ul>' +
          '<p>Bought one by one, those parts and priority delivery cost more than ' +
          'either bundle.</p>' +
          cta('Build your report', DATA.collectionUrl);
      }
    },
    {
      id: 'hairstyle',
      cues: ['hair', 'hairstyle', 'barber', 'stylist', 'cut', 'fringe', 'salon', 'hair direction'],
      answer: function () {
        return '<p>Hairstyle (' + priceOf('nuvora-hairstyle-recommendations') +
          ') gives you five exact hairstyles picked for your face, with cut and ' +
          'length notes your stylist or barber can follow and how to style each ' +
          'one at home, plus a before-and-after visual.</p>' +
          '<p>It is not the same as the hair direction in the Blueprint, which is ' +
          'general guidance on which lengths and shapes suit you.</p>' +
          cta('View Hairstyle', '/products/nuvora-hairstyle-recommendations');
      }
    },
    {
      id: 'makeup',
      cues: ['makeup', 'make-up', 'cosmetic', 'foundation', 'lipstick', 'colour palette'],
      answer: function () {
        return '<p>The Makeup Guide (' + priceOf('nuvora-makeup-recommendations') +
          ') gives you five complete looks built around your features, from ' +
          'everyday to evening, with step-by-step application and shades matched ' +
          'to your colouring, plus a before-and-after visual.</p>' +
          cta('View the Makeup Guide', '/products/nuvora-makeup-recommendations');
      }
    },
    {
      id: 'grooming',
      cues: ['beard', 'grooming', 'stubble', 'facial hair', 'moustache', 'mustache',
             'jawline', 'skincare', 'brows', 'eyewear', 'glasses', 'frames', 'spectacles'],
      answer: function () {
        return '<p>The Grooming Guide (' + priceOf('nuvora-grooming-eyewear-recommendations') +
          ') is for men: the beard shape and length that fit your jawline, a brow ' +
          'tidy and neckline guide, a simple skincare routine, and five eyewear ' +
          'frames that suit your face.</p>' +
          cta('View the Grooming Guide', '/products/nuvora-grooming-eyewear-recommendations');
      }
    },
    {
      id: 'privacy',
      cues: ['privacy', 'private', 'secure', 'data', 'share my', 'sell my',
             'confidential', 'gdpr', 'delete my'],
      answer: function () {
        return '<p>Your photos and details are used only to produce your analysis. ' +
          'They are not shared, sold, or kept beyond your report window, and no ' +
          'client data appears in any sample or marketing material.</p>' +
          cta('Read the privacy policy', '/policies/privacy-policy');
      }
    },
    {
      id: 'refund',
      cues: ['refund', 'money back', 'guarantee', 'cancel', 'cancellation'],
      answer: function () {
        return '<p>Changed your mind? You get a full refund within 7 days of ' +
          'purchase, as long as you have not sent your photos yet. Once your ' +
          'photos are in, your report goes into production. If something about ' +
          'your report is not right, contact us and it will be put right.</p>' +
          cta('Contact us', DATA.contactUrl);
      }
    },
    {
      id: 'personalised',
      cues: ['template', 'automated', 'generic', 'ai generated', 'real person',
             'personalised', 'personalized', 'custom', 'individually'],
      answer: function () {
        return '<p>Every report is produced individually from your own ' +
          'photographs. Nothing is inferred from a face-shape label and nothing ' +
          'is carried over from a template. Each measurement carries its own ' +
          'confidence, and where a reading is not reliable enough you are given ' +
          'the direction rather than a number.</p>' + BROWSE();
      }
    },
    {
      id: 'medical',
      cues: ['medical', 'doctor', 'surgery', 'surgical', 'dermatolog', 'diagnos',
             'health', 'clinic', 'botox', 'filler'],
      answer: function () {
        return '<p>No — NUVORA is an appearance and presentation service, not a ' +
          'medical one. Nothing in a report is medical, dermatological or ' +
          'surgical advice, and nothing recommended requires a procedure. For ' +
          'health or skin concerns, please see a qualified professional.</p>';
      }
    },
    {
      id: 'sample',
      cues: ['sample', 'example', 'preview', 'see what', 'show me', 'demo', 'look like'],
      answer: function () {
        return '<p>Explore selected report excerpts covering facial analysis, hairstyle, beard and eyewear recommendations. No email required.</p>' +
          cta('See what’s inside', DATA.howItWorksUrl);
      }
    },
    {
      id: 'validity',
      cues: ['valid', 'expire', '12 month', 'how long does it last', 'subscription',
             'recurring', 'renew'],
      answer: function () {
        return '<p>It is a one-time purchase, not a subscription. Your plan is ' +
          'valid for 12 months from purchase — to continue after that, simply ' +
          'purchase again.</p>' + BROWSE();
      }
    },
    {
      id: 'buy',
      cues: ['buy', 'order', 'purchase', 'checkout', 'get started', 'sign up',
             'start', 'how do i begin', 'ready'],
      answer: function () {
        return '<p>Pick the report that suits you, check out, and you will get a ' +
          'secure link by email to upload your five photos and fill in a short ' +
          'intake form. Your report follows in 3 to 5 business days.</p>' + BROWSE();
      }
    },
    {
      id: 'men',
      cues: ['men', 'male', 'man', 'guy', 'women', 'female', 'woman', 'gender',
             'for me', 'suitable'],
      answer: function () {
        return '<p>It works for anyone. The analysis measures your own ' +
          'proportions and the direction follows from those, so it is not built ' +
          'around one gender. The hairstyle and grooming direction is written for ' +
          'whatever suits you.</p>' + BROWSE();
      }
    },
    {
      id: 'contact',
      cues: ['contact', 'email', 'speak to', 'human', 'someone', 'support', 'help me'],
      answer: function () {
        return '<p>A real person is happy to help.</p>' +
          cta('Contact us', DATA.contactUrl);
      }
    }
  ];

  var GREETINGS = ['hi', 'hello', 'hey', 'good morning', 'good afternoon',
                   'good evening', 'howzit', 'hiya'];
  var THANKS = ['thanks', 'thank you', 'cheers', 'ta', 'appreciate'];

  /* -------------------------------------------------------------- matching */

  // Every cue above is plain lowercase letters, digits or a hyphen, so the
  // words can be compared directly and no regex escaping is needed.
  function words(text) {
    return text.toLowerCase().split(/[^a-z0-9-]+/).filter(Boolean);
  }

  function hasCue(text, tokens, cue) {
    // Multi-word cues are specific enough for a substring test.
    if (cue.indexOf(' ') !== -1) return text.indexOf(cue) !== -1;
    // Single words must match a whole word, allowing a plural or simple
    // suffix. Without this, "tax returns" hits the "return" cue and the
    // visitor gets the refund policy.
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (t === cue) return true;
      if (t.length > cue.length && t.length - cue.length <= 3 &&
          t.indexOf(cue) === 0) {
        return true;
      }
    }
    return false;
  }

  function score(text, tokens, entry) {
    var s = 0;
    for (var i = 0; i < entry.cues.length; i++) {
      var cue = entry.cues[i];
      if (hasCue(text, tokens, cue)) {
        // longer cues are more specific, so weight them higher
        s += cue.indexOf(' ') !== -1 ? 3 : 2;
      }
    }
    return s;
  }

  function match(text) {
    var tokens = words(text);
    var best = null, bestScore = 0;
    for (var i = 0; i < KB.length; i++) {
      var s = score(text, tokens, KB[i]);
      if (s > bestScore) { bestScore = s; best = KB[i]; }
    }
    return bestScore >= 2 ? best : null;
  }

  function anyOf(text, list) {
    for (var i = 0; i < list.length; i++) {
      if (text === list[i] || text.indexOf(list[i]) === 0) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------- ui */

  function add(html, who) {
    var el = document.createElement('div');
    el.className = 'nvc-msg nvc-msg--' + who;
    el.innerHTML = html;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function typing() {
    var el = document.createElement('div');
    el.className = 'nvc-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function setChips(items) {
    chips.innerHTML = '';
    items.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nvc-chip';
      b.textContent = t;
      b.addEventListener('click', function () { send(t); });
      chips.appendChild(b);
    });
  }

  var DEFAULT_CHIPS = ['What’s included?', 'How much is it?',
                       'How long does it take?', 'What photos do I send?'];

  /* --------------------------------------------------------------- answer */

  function remoteAnswer(text, priorTurns, done) {
    if (!DATA.endpoint) { done(null); return; }
    var payload = {
      message: text,
      // Turns before this one only. The current message travels separately as
      // `message`; including it here too made the model see it twice.
      history: priorTurns.slice(-8),
      context: {
        products: DATA.products,
        page: location.pathname
      }
    };
    var ctl = new AbortController();
    var t = setTimeout(function () { ctl.abort(); }, 15000);
    fetch(DATA.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctl.signal
    }).then(function (r) {
      clearTimeout(t);
      if (!r.ok) throw new Error('bad status');
      return r.json();
    }).then(function (j) {
      done(j && j.reply ? String(j.reply) : null);
    }).catch(function () {
      clearTimeout(t);
      done(null);
    });
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function fallback() {
    // Admitting the gap is the point: a sales assistant that invents answers
    // about a paid, personal service costs more trust than it wins.
    return '<p>I don’t have a confident answer for that one, and I’d ' +
      'rather not guess at it. Someone on the team can help you properly.</p>' +
      cta('Contact us', DATA.contactUrl);
  }

  var PRODUCT_LABELS = {
    'nuvora-complete-blueprint': 'View The Blueprint',
    'nuvora-complete-bundle': 'View The Full Look',
    'nuvora-full-upgrade': 'View The Full Upgrade',
    'nuvora-hairstyle-recommendations': 'View Hairstyle',
    'nuvora-makeup-recommendations': 'View the Makeup Guide',
    'nuvora-grooming-eyewear-recommendations': 'View the Grooming Guide',
    'priority-delivery': 'Add Priority Delivery'
  };

  // The model is asked to end with [[product:handle]] or [[browse]], but a
  // small model drifts from any format: it also writes [[handle]], or a bare
  // [[product: handle ]]. Accept all of those, and only for handles that
  // really exist, so an invented one can never become a dead button.
  function extractOffer(reply) {
    var offer = null;
    var cleaned = reply.replace(/\[\[\s*(?:product\s*:\s*)?([a-z0-9-]+)\s*\]\]/gi,
      function (_, token) {
        var t = token.toLowerCase();
        if (!offer) {
          if (t === 'browse') offer = { href: DATA.collectionUrl, label: 'See all reports' };
          else if (PRODUCT_LABELS[t] && product(t)) {
            offer = { href: product(t).url, label: PRODUCT_LABELS[t] };
          }
        }
        return '';
      });
    return { text: cleaned.replace(/[ \t]{2,}/g, ' ').trim(), offer: offer };
  }

  function renderReply(text, offer) {
    var paras = escapeHtml(text).split(/\n{2,}|\n/).filter(function (p) {
      return p.trim();
    });
    var html = paras.map(function (p) { return '<p>' + p.trim() + '</p>'; }).join('');
    if (offer) html += cta(offer.label, offer.href);
    return html;
  }

  // Scripted answers, used only when the model cannot be reached: no endpoint
  // configured, the free daily allowance spent, or a network failure. The
  // conversation then keeps working rather than going silent.
  function localAnswer(lower) {
    if (anyOf(lower, GREETINGS)) {
      return '<p>Hello. What would you like to know — what’s in a ' +
             'report, what it costs, or how long it takes?</p>';
    }
    if (anyOf(lower, THANKS)) {
      return '<p>Any time. When you’re ready, the full range is here.</p>' + BROWSE();
    }
    var hit = match(lower);
    return hit ? hit.answer() : fallback();
  }

  function respond(text, priorTurns) {
    var lower = text.toLowerCase().trim();
    var dots = typing();

    function finish(html, plain) {
      dots.remove();
      add(html, 'bot');
      history.push({ role: 'assistant', content: plain });
      setChips(DEFAULT_CHIPS);
    }

    // The model answers everything it can: that is what makes this a
    // conversation rather than a menu. The knowledge base is the fallback.
    remoteAnswer(text, priorTurns, function (reply) {
      if (reply) {
        var parsed = extractOffer(reply);
        if (parsed.text) {
          finish(renderReply(parsed.text, parsed.offer), parsed.text);
          return;
        }
      }
      var html = localAnswer(lower);
      finish(html, html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim());
    });
  }

  function send(text) {
    text = String(text || '').trim();
    if (!text) return;
    var priorTurns = history.slice();
    add(escapeHtml(text), 'me');
    history.push({ role: 'user', content: text });
    input.value = '';
    setChips([]);
    respond(text, priorTurns);
  }

  /* ---------------------------------------------------------------- open */

  function open() {
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    if (!started) {
      started = true;
      add('<p>Hello, I’m ' + NAME + '.</p>' +
          '<p>I can tell you what’s in a report, what it costs, how long ' +
          'it takes and which one suits you. Ask me anything — and if I ' +
          'don’t know, I’ll say so rather than guess.</p>', 'bot');
      setChips(DEFAULT_CHIPS);
    }
    setTimeout(function () { input.focus(); }, 50);
  }

  function close() {
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  }

  launcher.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    send(input.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });
})();

